import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';
import { useLenis } from 'lenis/react';
import { EffectFade } from 'swiper/modules';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import 'swiper/css';
import 'swiper/css/effect-fade';

const Slider = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const lenis = useLenis();

  const handleDownArrowClick = () => {
    if (lenis) {
      const viewportHeight = window.innerHeight;
      lenis.scrollTo(viewportHeight - 30);
    }
  };

  const slides = [
    {
      image: '/images/slider/0.jpg',
      title: t('slider_0_title'),
      description: t('slider_0_description'),
    },
    {
      image: '/images/slider/1.jpg',
      title: t('slider_1_title'),
      description: t('slider_1_description'),
    },
    {
      image: '/images/slider/2.jpg',
      title: t('slider_2_title'),
      description: t('slider_2_description'),
    },
    {
      image: '/images/slider/3.jpg',
      title: t('slider_3_title'),
      description: t('slider_3_description'),
    },
  ];

  const textVariants = {
    initial: { opacity: 0, y: 50 },
    animate: { opacity: 1, y: 0 },
    // exit: { opacity: 0, y: -50 },
  };

  return (
    <div className="bg-white">
      <div className="h-[calc(100vh-15rem)] w-full relative">
        <div className="absolute bottom-0 left-0 h-10 w-full z-50 flex justify-center space-x-2">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`h-2.5 w-2.5 ${activeIndex === index ? 'bg-genesisBlue' : 'bg-white'}`}
            ></div>
          ))}
        </div>

        <Swiper
          slidesPerView={1}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          className="h-full w-full"
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          modules={[EffectFade, Autoplay]}
          effect="fade"
          speed={3000}
          fadeEffect={{ crossFade: true }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide className="relative" key={index}>
              <motion.div
                className="absolute top-0 left-0 w-full h-full"
                initial={{ opacity: 0, scale: 1.1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 2, ease: "easeOut" }}
              >
                <img src={slide.image} alt={`Slide ${index}`} className="object-cover h-full w-full" />
              </motion.div>

              <div className="w-full bg-red grid grid-cols-11 relative h-full">
                <div className="col-start-2 col-span-9 lg:col-start-3 lg:col-span-7 z-50 py-20 grid grid-cols-1 md:grid-cols-2 md:gap-10 lg:gap-20 content-center">
                  <motion.div
                    className="text-white space-y-6"
                    key={activeIndex}
                    initial="initial"
                    animate="animate"
          
                    variants={textVariants}
                    transition={{ duration: 1.5, ease: "easeOut" }}
                  >
                    <h1 className="text-65 font-bold nunito-sans mb-5 leading-tight">{slide.title}</h1>
                    <motion.p
                      className="text-lg leading-relaxed"
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 1.5, ease: "easeOut", delay: 0.2 }}
                    >
                      {slide.description}
                    </motion.p>
                  </motion.div>
                </div>
              </div>
              <div className="absolute h-full w-full bg-genesisBlue top-0 left-0 mix-blend-multiply opacity-30"></div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="w-full flex justify-center py-6">
        <img
          onClick={handleDownArrowClick}
          src="/images/icons/down-arrow.svg"
          className="w-14 cursor-pointer hover:scale-105 duration-300"
          alt="Down Arrow"
        />
      </div>
    </div>
  );
};

export default Slider;
